import Vue from 'vue'
import Router from 'vue-router'
import Info from '@/views/Info.vue'
import Location from '@/views/Location.vue'
import Online from '@/views/Online.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [{
    path: '/',
    component: Info
  },
  {
    name: 'location',
    path: '/location',
    component: Location
  },
  {
    path: '/online',
    component: Online
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue')
  }, {
    path: '/complete',
    component: () => import('@/views/Complete.vue')
  }
  ]
})
